import React, { useState } from "react";

const EditInvestorD = () => {
  const [investorTitle, setInvestorTitle] = useState("");
  const [investorParagraphs, setInvestorParagraphs] = useState([""]);

  const handleTitleChange = (e) => {
    setInvestorTitle(e.target.value);
  };

  const handleParagraphChange = (index, e) => {
    const newParagraphs = [...investorParagraphs];
    newParagraphs[index] = e.target.value;
    setInvestorParagraphs(newParagraphs);
  };

  const handleAddParagraph = () => {
    setInvestorParagraphs([...investorParagraphs, ""]);
  };

  const handleRemoveParagraph = (index) => {
    setInvestorParagraphs(investorParagraphs.filter((_, i) => i !== index));
  };

  const handleSaveChanges = () => {
    const data = { investorTitle, investorParagraphs };
    console.log("Saving changes:", data);
    // Replace with API call or other save logic
  };

  return (
    <div className="edit-about edit-investor-details">
      <h2>Edit Investor Details</h2>

      {/* Title Input */}
      <div className="form-group">
        <label htmlFor="investorTitle">Investor Title</label>
        <input
          type="text"
          id="investorTitle"
          value={investorTitle}
          onChange={handleTitleChange}
          placeholder="Enter investor title"
        />
      </div>

      {/* Paragraphs Input */}
      {investorParagraphs.map((paragraph, index) => (
        <div key={index} className="form-group paragraph-group">
          <label htmlFor={`paragraph-${index}`}>Paragraph {index + 1}</label>
          <textarea
            id={`paragraph-${index}`}
            value={paragraph}
            onChange={(e) => handleParagraphChange(index, e)}
            placeholder="Enter details about the investor"
          ></textarea>
          {investorParagraphs.length > 1 && (
            <button
              type="button"
              onClick={() => handleRemoveParagraph(index)}
              className="remove-paragraph-btn"
            >
              Remove
            </button>
          )}
        </div>
      ))}

      {/* Add More Paragraph Button */}
      <button type="button" onClick={handleAddParagraph} className="add-paragraph-btn">
        Add More Paragraph
      </button>

      {/* Save Changes Button */}
      <button type="button" onClick={handleSaveChanges} className="save-btn">
        Save Changes
      </button>
    </div>
  );
};

export default EditInvestorD;
